'use strict';

var isCssVariable = require('../../../../../../../motion-dom/dist/es/animation/utils/is-css-variable.cjs');

const scaleCorrectors = {};
function addScaleCorrector(correctors) {
    for (const key in correctors) {
        scaleCorrectors[key] = correctors[key];
        if (isCssVariable.isCSSVariableName(key)) {
            scaleCorrectors[key].isCSSVariable = true;
        }
    }
}

exports.addScaleCorrector = addScaleCorrector;
exports.scaleCorrectors = scaleCorrectors;
//# sourceMappingURL=scale-correction.cjs.map
